import React, { useMemo, useCallback } from "react";
import { SelectPicker, Input, Schema, Checkbox } from "rsuite";
import styled from "styled-components";

import { renderColumn } from "utils";
import TableEditCellsNew from "components/Table/TableEditCells/TableEditCellsNew";

const { StringType, BooleanType } = Schema.Types;


export default ({
    data = [],
    isMobile,
    mccMncList,
    dialerList,
    supplierList,
    editKeys,


    exceptionMap,

    setEditKeys,
    setExceptionMap,

    ...props
}) => {

    const rowFormModel = useCallback((data) => {
        // const senderFilled = !!formValue?.senderid?.trim();
        // const langFilled = !!formValue?.language?.trim();
        const supplierFilled = !!data?.supplier_id;

        const needSenderLang = !supplierFilled;

        return Schema.Model({
            senderid: needSenderLang
                ? StringType()
                    .isRequired("Requied when Supplier empty")
                    .minLength(3, "Min characters 3")
                    .maxLength(40, "Max characters 40")
                : StringType()
                    .minLength(3, "Min characters 3")
                    .maxLength(40, "Max characters 40"),

            language: needSenderLang
                ? StringType()
                    .isRequired("Requied when Supplier empty")
                    .minLength(2, "Min characters 2")
                    .maxLength(40, "Max characters 40")
                : StringType()
                    .minLength(2, "Min characters 2")
                    .maxLength(40, "Max characters 40"),

            supplier_id: StringType(),
            mcc_mnc: StringType(),
            dialer_id: StringType(),
            not_exception: BooleanType()
        });
    });

    const columns = useMemo(() => [
        {
            id: "senderid",
            name: "Senderid",
            dataKey: "senderid",
            align: "left",
            className: "senderid",
            width: 230,
            rowModel: rowFormModel,

            accepter: Input
        },
        {
            id: "language",
            name: "Message Language",
            dataKey: "language",
            align: "center",
            className: "language",
            width: 200,
            rowModel: rowFormModel,

            accepter: Input
        },
        {
            id: "supplier_id",
            name: "Supplier Name",
            dataKey: "supplier_id",
            value: ({ supplier_name }) => {
                return supplier_name || "";
            },

            align: "left",
            placeholder: "Supplier...",
            className: "supplier_id",
            // width: 120,
            flexGrow: 1,
            rowModel: rowFormModel,
            checkRowModel: true,

            accepter: SelectPicker,
            data: supplierList || [],
            valueKey: "supplier_id",
            labelKey: "name"
        },
        {
            id: "mcc_mnc",
            name: "Destination",
            dataKey: "mcc_mnc",
            value: ({ mcc_mnc }) => {
                const currentMccMncData = mccMncList.find((item) => item.mcc_mnc === mcc_mnc);
                return currentMccMncData?.nameMccMnc || "";
            },
            align: "left",
            placeholder: "Destination...",

            // minWidth: 300,
            flexGrow: 2,
            rowModel: rowFormModel,

            accepter: SelectPicker,
            data: mccMncList,
            valueKey: "mcc_mnc",
            labelKey: "nameMccMnc"
        },
        {
            id: "dialer_id",
            name: "Dialer",
            dataKey: "dialer_id",
            className: "dialer_id",
            value: ({ dialer_name }) => {
                return dialer_name || "";
            },
            align: "left",
            flexGrow: 1,
            rowModel: rowFormModel,

            accepter: SelectPicker,
            data: dialerList || [],
            valueKey: "id",
            labelKey: "name"
        },
        {
            id: "do_not_send",
            name: "Do not send",
            dataKey: "do_not_send",
            value: ({ sms_language_exception_key: key, do_not_send }) => {
                const checked = exceptionMap.has(key)
                    ? exceptionMap.get(key)
                    : Boolean(do_not_send);
                const notEditing = !editKeys.find(editKey => editKey === key);

                return (
                    <StyledCheckbox
                        checked={checked}
                        disabled={notEditing}
                        onChange={(_, checked) => {
                            setExceptionMap(prev => {
                                const newMap = new Map(prev);
                                newMap.set(key, checked);
                                return newMap;
                            });

                        }}
                    />
                );
            },
            align: "center",
            width: 112,
            rowModel: rowFormModel
        }

    ], [data, exceptionMap, setExceptionMap, mccMncList, supplierList, dialerList]);

    const renderedColumns = columns.map(renderColumn);

    return (
        <>
            <StyledTable
                rowKey="sms_language_exception_key"
                rowIdKey="sms_language_exception_key"
                autoHeight={false}
                shouldUpdateScroll={false}
                headerHeight={46}
                rowHeight={44}
                height={662}
                rowClassName={(rowData) => {
                    if (rowData && rowData.do_not_send !== null) {
                        return rowData.do_not_send ? "red" : "green";
                    }
                }}

                // wordWrap
                data={data}

                errorPlacement={"bottom"}
                columns={columns}
                addButtonWidth={124}

                editKeys={editKeys}
                setEditKeys={setEditKeys}

                clearOnCancel

                {...props}
            >
                {renderedColumns}
            </StyledTable>
        </>
    );
};

const StyledTable = styled(TableEditCellsNew)`
    && {
        .rs-table-row.red .rs-table-cell {
            background: #f7dddd;
        }
        
        .rs-table-row.green .rs-table-cell {
            background: #e2f6de;
        }

         .rs-table-body-row-wrapper .rs-table-cell-content .tableFilters_buttons > .rs-btn {
            width: 30px;
            height: 30px;
            padding: 4px 8px;
        }
        
        .rs-table-body-row-wrapper .rs-table-cell-content .tableFilters_buttons > .rs-btn {
            margin-right: 5px;
        }
        .rs-table-body-row-wrapper .rs-table-cell-content .tableFilters_buttons .rs-btn-lightblue {
            color: var(--color-light);
            background: var(--color-info);
        }

        .rs-form-control-wrapper .rs-error-message.rs-error-message-show {
            top: -6px;
            right: 0px;
            height: 18px;
            border-radius: 10px;
            padding-top: 0;
            border: 0px;

            .rs-error-message-arrow {
                display: none;
            }

            .rs-error-message-inner {
                font-size: 11px;
            }
        }
    }
`;

const StyledCheckbox = styled(Checkbox)`
    && {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    && .rs-checkbox-wrapper {
        top: 0px !important;
    }
`;